import React, { useState } from "react";
import { FaShoppingCart, FaBars, FaTimes, FaUser } from "react-icons/fa";
import { useCartStore } from "../store/cartStore";
import { useCategoryStore } from "../store/categoryStore";
import AuthModal from "./AuthModal";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export default function Header() {
  const navigate = useNavigate();
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const cart = useCartStore((s) => s.cart);
  // Total quantity in cart
  const cartCount = Array.isArray(cart)
    ? cart.reduce((sum, item) => sum + (item.quantity || 1), 0)
    : 0;

  const categories = useCategoryStore((s) => s.categories);

  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const user = useAuthStore((state) => state.user);

  const userInitials = user?.name
    ? user.name
        .trim()
        .split(" ")
        .filter(Boolean)
        .map((name) => name[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "";

  const handleUserClick = () => {
    if (isLoggedIn) {
      navigate("/profile");
    } else {
      setAuthOpen(true);
    }
  };

  return (
    <>
      <header className="sticky top-0 z-50 bg-off_white text-gray-100 px-6 md:px-16 py-4">
        <div className="flex items-center justify-between">
          {/* LEFT: LOGO */}
          <div className="flex items-center gap-2">
            <img
              src="/img/logo.jpg"
              alt="Legacy Decor Logo"
              className="h-10 md:h-16 w-auto object-contain inline mr-2"
            />
            <a href="/" className="flex flex-col">
              <img
                src="/img/title.png"
                alt="Legacy Decor "
                className="h-5 md:h-8 lg:h-8 w-auto object-contain"
              />
              <span className="ml-3 text-[10px] md:text-xs lg:text-sm tracking-[0.2em] uppercase text-[#B88A3B] mt-1">
                The Art Of Vintage Luxury
              </span>
            </a>
          </div>

          {/* RIGHT SIDE: MENU + ICONS */}
          <div className="flex items-center gap-8 md:gap-10">
            {/* Desktop Menu RIGHT ALIGNED */}
            <nav className="hidden lg:flex items-center gap-4 uppercase1 font-medium text-black">
              <a href="/" className="hover:text-primary">
                Home
              </a>
              {/* Categories Dropdown */}
              <div className="relative group">
                <a
                  href="/categories"
                  className="hover:text-primary flex items-center gap-1"
                >
                  Categories
                </a>

                <div
                  className="
                        absolute left-0 top-full mt-2
                        w-64
                        bg-white
                        shadow-xl
                        rounded-lg
                        py-2
                        opacity-0
                        invisible
                        group-hover:opacity-100
                        group-hover:visible
                        transition-all
                        duration-200
                        z-50
                      "
                >
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={`/products/${cat.slug}`}
                      className="block px-5 py-2 text-black hover:bg-product_bg hover:text-primary"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <a href="/products" className="hover:text-primary">
                Products
              </a>
              <a href="/about" className="hover:text-primary">
                About
              </a>
              <a href="/contact" className="hover:text-primary">
                Contact
              </a>
            </nav>

            {/* Icons */}
            <div className="flex items-center gap-5">
              <a
                href="/cart"
                className="relative text-2xl text-light_primary hover:text-hover_light_primary"
              >
                <FaShoppingCart />
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-3 bg-pink-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </a>

              {/* Account */}
              <button
                onClick={handleUserClick}
                //onClick={() => setAuthOpen(true)}
                className="text-2xl text-light_primary hover:text-hover_light_primary"
                aria-label="Login or Sign Up"
              >
                {isLoggedIn && userInitials ? (
                  <span className="w-9 h-9 rounded-full bg-light_primary text-white flex items-center justify-center text-sm font-semibold">
                    {userInitials}
                  </span>
                ) : (
                  <FaUser className="text-2xl" />
                )}
              </button>

              {/* Hamburger (mobile) */}
              <button
                className="lg:hidden text-3xl text-light_primary hover:text-hover_light_primary"
                onClick={() => setOpen(!open)}
              >
                {open ? <FaTimes /> : <FaBars />}
              </button>
            </div>
          </div>
        </div>

        {/* MOBILE MENU */}
        {open && (
          <div className="mt-4 flex flex-col gap-4 lg:hidden text-sm uppercase bg-product_bg p-4 rounded-lg">
            <a href="/" className="text-black hover:text-primary">
              Home
            </a>
            <div>
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className="w-full flex items-center justify-between text-black hover:text-primary"
              >
                <span>Categories</span>
                <span>{categoryOpen ? "−" : "+"}</span>
              </button>

              {categoryOpen && (
                <div className="mt-2 ml-4 flex flex-col gap-2 pl-4">
                  {categories.map((cat) => (
                    <a
                      key={cat._id}
                      href={`/products/${cat.slug}`}
                      className="text-gray-700 hover:text-primary text-sm normal-case"
                      onClick={() => {
                        setOpen(false);
                        setCategoryOpen(false);
                      }}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
            <a href="/products" className="text-black hover:text-primary">
              Products
            </a>
            <a href="/about" className=" text-black hover:text-primary">
              About
            </a>
            <a href="/contact" className="text-black hover:text-primary">
              Contact
            </a>
          </div>
        )}
      </header>

      {/* AUTH MODAL */}
      {authOpen && <AuthModal onClose={() => setAuthOpen(false)} />}
    </>
  );
}
